import { SupervisorProductCost } from '../../models/SupervisorProductCost';
import { DataResult } from '../../utils/DataResult';
import { BaseApiService, toRequestError } from './http';

function isSupervisorProductCost(
  value: unknown,
): value is SupervisorProductCost {
  const cost = value as SupervisorProductCost | null;

  return (
    typeof cost === 'object' &&
    cost !== null &&
    typeof cost.catalogRefId === 'string' &&
    typeof cost.cost === 'number' &&
    Number.isFinite(cost.cost)
  );
}

/**
 * Handles the supervisor views over licenses and tools under cost center
 * supervision.
 */
export class SupervisorService extends BaseApiService {
  async getLicensesUnderSupervisor(
    catalogRefId?: string,
  ): Promise<SupervisorProductCost[]> {
    const query = new URLSearchParams();

    if (catalogRefId) {
      query.set('catalogRefId', catalogRefId);
    }

    const search = query.toString();
    const suffix = search ? `?${search}` : '';

    return this.fetchArray(
      `/supervisor/licenses-under-supervisor${suffix}`,
      isSupervisorProductCost,
    );
  }

  async getToolsUnderSupervisor(): Promise<SupervisorProductCost[]> {
    return this.fetchArray(
      '/supervisor/tools/costcenter',
      isSupervisorProductCost,
    );
  }

  async getToolCostUnderSupervisor(
    catalogRefId: string,
  ): Promise<SupervisorProductCost | undefined> {
    const baseUrl = await this.getBaseUrl();
    const query = new URLSearchParams({ catalogRefId });

    const response = await this.fetchApi.fetch(
      `${baseUrl}/supervisor/tool-cost/costcenter?${query.toString()}`,
    );

    if (!response.ok) {
      throw await toRequestError(response);
    }

    const body: DataResult<unknown> | null = await response.json();

    return isSupervisorProductCost(body?.data) ? body.data : undefined;
  }
}
